<script setup lang="ts">
import { computed } from 'vue'

/**
 * Determinate progress bar — a rounded gray track with a primary-emerald fill. Consolidates the
 * inline `h-2 rounded-full` download bars (and retires the off-palette blue fill onto the primary
 * token). `value` is a 0–100 percentage (clamped). Single-root so extra classes fall through.
 */
interface Props {
  value: number
}
const props = defineProps<Props>()
const pct = computed(() => Math.max(0, Math.min(100, props.value)))
</script>

<template>
  <div
    class="h-2 w-full overflow-hidden rounded-full bg-gray-200"
    role="progressbar"
    :aria-valuenow="pct"
    aria-valuemin="0"
    aria-valuemax="100"
  >
    <div
      class="h-full rounded-full bg-primary-500 transition-all duration-300"
      :style="{ width: pct + '%' }"
    />
  </div>
</template>
